/* eslint-disable max-len */
import React from 'react';

const InstagramIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M13 2c2.21 0 4 1.79 4 4v7c0 2.21-1.79 4-4 4H6c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h7zm0 1H6C4.343 3 3 4.343 3 6v7c0 1.657 1.343 3 3 3h7c1.657 0 3-1.343 3-3V6c0-1.657-1.343-3-3-3z"
      />
      <circle cx="9.5" cy="9.5" r="3" stroke="currentColor" />
      <path
        fill="currentColor"
        d="M14.4 5.5c0 .497-.403.9-.9.9s-.9-.403-.9-.9.403-.9.9-.9.9.403.9.9"
      />
    </g>
  </svg>
);

export default InstagramIcon;
